export const CARTS_LOCAL = 'carts_local'
export const LOCAL_EMAIL_RESET_PASSWORD = 'email_reset_password'

export const LOCAL_PHONE_VERIFY = 'local_phone_verify'

export const LOCAL_REELS = 'locals_reel'
export const LOCAL_REELS_LIKE = 'locals_reel_like'

export const LOCAL_SHIPPING_ADDRESSES = 'local_shipping_addresses'
